import { PagePermission } from "@services/usePermission";
import { setAncNumber, setAncPregBackHandler, setLmpDate, updateAncService, updatePNC } from "@store/actions/beneficiaryAction";
import FormatDate from '@utils/dateFormat';
import dayjs from "dayjs";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditIcon from '../../../../../src/assets/svg_main/edit_outline.svg';
import EyeClose from '../../../../../src/assets/svg_main/eye-closed.svg';
import EyeOpen from '../../../../../src/assets/svg_main/eye-open.svg';
import Info from '../../../../../src/assets/svg_main/info.svg';
import './index.css';
import PregnancyInfoBar from "./PregnancyInfoBar";
import { RootState } from "@store/reducers";
import { useSelector } from "react-redux";
import { pregnancy_details_constant } from "@constants/appConstants";
import { onSameDay } from "./pregnancyUtils";
import { dateFormate } from "@constants/index";
import { benef_const, benef_life_calendar_const } from "@constants/beneficiaryConstant";
import { PNC_COMMON_CONSTANTS } from "../PNC/PNCConstants";

const PregnancyDetails = ({ data, periodName, idx, isExpandAll, isChild, hasDeliveryService, latestServiceDate, latestPNCMotherCreateDate, periodCreateDate, latestANCCreateDate }: any) => {  const [showModal, setShowModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const canEditServices = PagePermission("Benf_Service", "Service_EdPg");
  const canViewServices = PagePermission("Benf_Service", "Service_OVPg");
  const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);
  const childDetail = useSelector((state: RootState) => state.beneficiary.childDetails);
  const canEditANCService = useSelector((state: RootState) => state.beneficiary.canEditANCService);
  const pageMenuFromLifeCalendar = useSelector((state: RootState) => state.beneficiary.pageMenuFromLifeCalendar);
  const viewPregnancyDetails = useSelector((state: RootState) => state.beneficiary.viewPregnancyDetails);

  const handleShowModal = () => {
    setShowModal((prev) => !prev);
  }

  const editNavigationMap: any = {
    'anc_usg': '/beneficiaries/anc-service/edit/usg',
    'anc_rout_anc': '/beneficiaries/anc-service/edit/routine-anc',
    'anc_spl_tst': '/beneficiaries/anc-service/edit/special-test',
    'anc_td': '/beneficiaries/anc-service/edit/td-injection',
    'anc_anc_serv': '/beneficiaries/anc-service/edit/anc-service-form',
    'anc_pe_oh': '/beneficiaries/anc-service/edit/pe-obstretricHistory',
    'pnc_mother': '/beneficiaries/pnc/edit/pnc-mother',
    'pnc_child': '/beneficiaries/child/edit/pnc-child',
    'hbyc': '/beneficiaries/child/edit/hbyc'
  };

  const viewNavigationMap: any = {
    'anc_usg': '/beneficiaries/anc-service/overview/usg',
    'anc_rout_anc': '/beneficiaries/anc-service/overview/routine-anc',
    'anc_spl_tst': '/beneficiaries/anc-service/overview/special-test',
    'anc_td': '/beneficiaries/anc-service/overview/td-injection',
    'anc_anc_serv': '/beneficiaries/anc-service/overview/anc-service-form',
    'anc_pe_oh': '/beneficiaries/anc-service/overview/pe-obstretricHistory',
    'pnc_mother': '/beneficiaries/pnc/overview/pnc-mother',
    'pnc_child': '/beneficiaries/child/view/pnc-child',
    'hbyc': '/beneficiaries/child/view/hbyc'
  };

  const handleEdit = (item: any) => {
    const editObj: any = {
      ancVisitDate: dayjs(getVisitDate(item), dateFormate.dd_mm_yyyy).format(dateFormate.yyyy_mm_dd),
      ancNo: periodName?.match(/\d+/) ? periodName.match(/\d+/)[0] : 0,
      serviceSubCategoryId: item?.service_subcategory_id,
      serviceVisitId: item?.benef_service_visit_id,
      isServiceTakenOutside: item?.is_from_outside_api
    }
    const ancPregBackObj = {
      benfType: "female",
      menuItems: "Pregnancy Services",
      ancListItemIdx: idx,
      periodName: periodName,
      ancNo: periodName?.match(/\d+/) ? periodName.match(/\d+/)[0] : 0,
      isExpandAll: isExpandAll,
    }
    const ancNo = periodName?.match(/\d+/) ? parseInt(periodName.match(/\d+/)[0]) : 0;
    dispatch(setAncNumber(ancNo));
    dispatch(setAncPregBackHandler(ancPregBackObj));
    dispatch(updateAncService('onSameDay', true));
    dispatch(updatePNC('pncOnSameDay', true));
    dispatch(updateAncService('serviceCtgryId', item?.service_category_id));
    dispatch(updateAncService('currServiceSubCtgryId', item?.service_subcategory_id));
    dispatch(updateAncService('viewEditMetaData', editObj));
    dispatch(updateAncService('isEditButtonClicked', true));
    dispatch(updateAncService('isPNCFirstVisit', item?.is_pregnancy_registered_outside));
    if (viewPregnancyDetails?.lmp) {
      dispatch(setLmpDate(FormatDate(viewPregnancyDetails.lmp)));
    }
    navigate(editNavigationMap[item.service_code]);
  }

  const handleClosureView = (item: any) => {
    switch (item.service_period_name) {
      case 'Delivery Details ': {
        navigate('/beneficiaries/service/overview/delivery-details')
      } break;
      case 'Abortion Care ': {
        navigate('/beneficiaries/abortion/view/abortion')
      } break;


    }
  }

  const handleView = (item: any) => {
    const viewObj: any = {
      ancVisitDate: dayjs(getVisitDate(item), dateFormate.dd_mm_yyyy).format(dateFormate.yyyy_mm_dd),
      ancNo: periodName?.match(/\d+/) ? periodName.match(/\d+/)[0] : 0,
      serviceSubCategoryId: item?.service_subcategory_id,
      serviceVisitId: item?.benef_service_visit_id,
      isServiceTakenOutside: item?.is_from_outside_api
    }
    const ancPregBackObj = {
      benfType: "female",
      menuItems: "Pregnancy Services",
      ancListItemIdx: idx,
      periodName: periodName,
      ancNo: periodName?.match(/\d+/) ? periodName.match(/\d+/)[0] : 0,
      isExpandAll: isExpandAll,
    }
    dispatch(setAncPregBackHandler(ancPregBackObj));
    dispatch(updateAncService('onSameDay', true));
    dispatch(updateAncService('currServiceSubCtgryId', item?.service_subcategory_id));
    dispatch(updateAncService('viewEditMetaData', viewObj));
    dispatch(updateAncService('isPNCFirstVisit', item?.is_pregnancy_registered_outside));
    navigate(viewNavigationMap[item.service_code]);
  }

  const isLatestServiceOfType = (item: any): boolean => {
    const sameTypeServices = data[periodName]?.filter(
      (s: any) => s.service_code === item.service_code
    );

    if (!sameTypeServices || sameTypeServices.length === 0) return false;

    const latestDate = sameTypeServices.reduce((max: any, s: any) => {
      const date = dayjs(s.create_date);
      return date.isAfter(max) ? date : max;
    }, dayjs(sameTypeServices[0].create_date));

    return dayjs(item.create_date).isSame(latestDate, 'day');
  };

  const showEditIcon = (item: any) => {
    if(item.service_code.includes('anc')){
       return canEditANCService && !!latestANCCreateDate && dayjs(item.create_date).isSame(dayjs(latestANCCreateDate), 'day') && isLatestServiceOfType(item) && dayjs().diff(dayjs(item.create_date), 'day') <= 90;
    }
    switch (item.service_code) {
      case pregnancy_details_constant.pncMother: {
        if (!latestPNCMotherCreateDate || !periodCreateDate) {
          return onSameDay(item.create_date) && isLatestServiceOfType(item);
        }
        const isLatestCreatedPeriod = !dayjs(periodCreateDate).isBefore(dayjs(latestPNCMotherCreateDate));
        return isLatestCreatedPeriod && dayjs().diff(dayjs(periodCreateDate), 'day') <= 90 && isLatestServiceOfType(item);
      }
      case pregnancy_details_constant.pncChild: {
        const isOnLatestDate = (isChild && latestServiceDate)
          ? dayjs(item.create_date).format(dateFormate.dd_mm_yyyy) === dayjs(latestServiceDate).format(dateFormate.dd_mm_yyyy)
          : true;
        return !isChildDead() && isLatestServiceOfType(item) && isOnLatestDate && dayjs().diff(dayjs(item.create_date), 'day') <= 90;
      }
      case pregnancy_details_constant.hbyc: {
        const isOnLatestDate = (isChild && latestServiceDate)
          ? dayjs(item.create_date).format(dateFormate.dd_mm_yyyy) === dayjs(latestServiceDate).format(dateFormate.dd_mm_yyyy)
          : true;
        return !isChildDead() && isLatestServiceOfType(item) && isOnLatestDate && dayjs().diff(dayjs(item.create_date), 'day') <= 90;
      }
      case pregnancy_details_constant.anc: {
        return canEditANCService
      }
      default: {
        if (hasDeliveryService) {
          return false;
        }
        return dayjs(item.create_date).format(dateFormate.dd_mm_yyyy) === dayjs(new Date()).format(dateFormate.dd_mm_yyyy);
      }
    }
  }

  const isChildDead = () => {
    return childDetail?.is_dead;
  }

  const getVisitDate = (item: any) => {
    switch (item.service_code) {
      case pregnancy_details_constant.pncMother:
        return dayjs(item.pnc_visit_date).format(dateFormate.dd_mm_yyyy);
      case pregnancy_details_constant.pncChild:
        return dayjs(item.hbnc_visit_date).format(dateFormate.dd_mm_yyyy);
      case pregnancy_details_constant.hbyc:
        return dayjs(item.hbyc_visit_date).format(dateFormate.dd_mm_yyyy);
      default:
        return item.anc_visit_date ? dayjs(item.anc_visit_date).format(dateFormate.dd_mm_yyyy) : '';
    }
  }
  const checkAutoClosure = () => {
    return (data[periodName]?.some((item: any) => item.module_code === PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY) && periodName === benef_const.deliveryServiceCode)
  };

  const handleCheckFromLifeCalendar = () => {
    return (pageMenuFromLifeCalendar?.isNavigateFromLifeEvent && (!pageMenuFromLifeCalendar?.currentServices && !(pageMenuFromLifeCalendar?.naviGationType === benef_life_calendar_const.pregnancyStatus.on_going)))
  };


  return (
    <>
      {(benef_const.pregnancyClosedServiceNames.includes(periodName) || (checkAutoClosure()))
        ? data[periodName]?.map((item: any, index: any) => (
          <div className="pregnancy-registration-body" key={index}>
            <div className="pregnancy-sub-services">
              <span className="service-name">{item.module_code === PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY ? PNC_COMMON_CONSTANTS.SYSTEM_CLOSED :
               (item.module_code === PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY && item.service_category_name === PNC_COMMON_CONSTANTS.DELIVERY_DETAILS) ? PNC_COMMON_CONSTANTS.DELIVERY_OUTSIDE_RCH : 
               (item.module_code === PNC_COMMON_CONSTANTS.ABORTION_DETAILS && item.service_category_name ===PNC_COMMON_CONSTANTS.ABORTION_CARE ) ? PNC_COMMON_CONSTANTS.ABORTION_CARE :
                (item.module_code === PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY && item.service_category_name ===PNC_COMMON_CONSTANTS.ABORTION_CARE  ) ? PNC_COMMON_CONSTANTS.ABORTION_OUTSIDE_RCH:''}</span>
              <span className="closure-service-icon"></span>
              <span className="service-date">{dayjs(item.service_start_dt).format(dateFormate.dd_mm_yyyy)}</span>
              <span className="edit-icon-container">
                {(canViewServices && benef_const.pregnancyClosedViewServiceNames.includes(periodName) && (item.module_code !== PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY)) && (
                  <span onClick={() => handleClosureView(item)}>
                    {<EyeOpen />}
                  </span>
                )}

              </span>
            </div>
          </div>
        ))
        : data[periodName]?.map((item: any, index: any) => (
          <div className="pregnancy-registration-body" key={index}>
            <div className="pregnancy-sub-services">
              <span className="service-name">{item.service_name}</span>
              <span className="service-icon"><PregnancyInfoBar item={item} /></span>
              <span className="service-date">{getVisitDate(item)}</span>
              <span className="edit-icon-container">
                {(canEditServices && showEditIcon(item) && !handleCheckFromLifeCalendar() && (isChild || !benfDetails?.[0].is_dead)) && (
                  <span onClick={() => handleEdit(item)}>
                    <EditIcon />
                  </span>
                )}
                {canViewServices && (
                  <span onClick={() => handleView(item)}>
                    {showModal ? <EyeClose /> : <EyeOpen />}
                  </span>
                )}
              </span>
            </div>
          </div>
        ))}
    </>

  )
}

export default PregnancyDetails;	